module.exports = __webpack_public_path__ + "img/png04.9a079ab3.png";